module.exports = __webpack_public_path__ + "static/img/bg_mod_media.9b00b297.jpg";